import React,{useState,useEffect} from 'react';
import { Row, Col, Image} from 'react-bootstrap';
import { Navbar, Nav, Container} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faCircleNotch, faAngleLeft,faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isBrowser, isMobileSafari, isMobile } from 'react-device-detect';
import { useLanguage } from '../i18n/LanguageContext';
import { loadAndParseXml } from '../i18n/xmlLoader';

function Section(props) {
  const { language, t } = useLanguage();
  const [sectionContent, setContent] = useState({title:"", content:null});
  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
  var myRef = React.createRef();
 
  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    loadAndParseXml(props.topic + ".xml", language, function (err, result) {
      if (err) {
        alert(t('common.cannotReadGuide'));
        return;
      }
      try{
          var section = result.section;
          var title = section.title[0];
          var content = section.content[0];
          content = content.replace("{height}", (window.outerHeight - 130) + 'px');
          content = content.replace("{width}", window.outerWidth.toString() + 'px');
          setContent({title:title, content:content});
          if (myRef.current) myRef.current.scrollTo(0, 0);
      }
      catch(ex){
        alert(t('common.cannotReadGuide'));
      }
    });
  }, [props.topic, language]);

  useEffect(() => {

    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

    function handleSelect(key){
      if (key=="back"){
        props.onBackSelected();
      }
    }

    function getContent(){
      var cHeight = '100vh';
      if (isBrowser || isMobileSafari){
        cHeight = height + 'px';
      }
        return (
          <div style={{backgroundColor:`${bgColor}`, padding:`${padding}`, overflow:'auto', height:'calc(' + cHeight + ' - 75px - env(safe-area-inset-top))'}} >
            <div ref={myRef} dangerouslySetInnerHTML={{ __html: sectionContent.content }}></div>
          </div>
        )
    }
    var bgColor = "transparent"
    var padding = "66px 0px 65px 0px";
    
    return (
      <div>
        <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
          <Nav  style={{width: "100%"}}  onSelect={handleSelect}>
            <Nav.Link eventKey="back" style={{textAlign: "left", marginLeft:"10px"}}>
            <div style={{paddingTop:0, paddingBottom:0, fontSize:'1.2rem', color:'lightgray'}} onTouchEnd={handleSelect.bind(this, "back")}><span aria-hidden="true" class="carousel-control-prev-icon" style={{verticalAlign:'middle'}}></span> <span style={{verticalAlign:'middle'}}>{sectionContent.title}</span></div></Nav.Link>
          </Nav>
        </Navbar>
        {getContent()}
      </div>
    )
};

export default Section;